// Material UI
import {
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  DialogActions,
  Button,
} from "@mui/material";

function DialogJob({ open, handleClose, listIndustri, handleSelect }) {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Pilih Job Trending</DialogTitle>
      <DialogContent>
        <List>
          {listIndustri?.map((item, idx) => {
            return (
              <ListItem
                key={idx}
                button
                onClick={() =>
                  handleSelect(item)
                }
              >
                <ListItemText primary={item} />
              </ListItem>
            );
          })}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogJob;
